import React from 'react';

import { InfoRailIcon_legacy, StateCriticalIcon, StatePendingIcon } from '@tanium/react-graphics';
import { Bars } from '@tanium/react-spinner';

import { ChartStatus } from '../../utils/ChartStatus';
import { EmptyStateProps } from './EmptyState';
import {
  DefaultBorderColor,
  DefaultFill,
  DefaultText,
  ErrorBorderColor,
  ErrorFill,
  ErrorIconFill,
  ErrorText,
  InfoIconFill,
  LoadingBorderColor,
  LoadingFill,
  PendingIconFill,
} from './themeDefinitions';

export const emptyStateProps: Record<ChartStatus, EmptyStateProps> = {
  error: {
    bg: ErrorFill,
    color: ErrorText,
    icon: StateCriticalIcon,
    iconColor: ErrorIconFill,
    borderColor: ErrorBorderColor,
  },
  info: {
    bg: DefaultFill,
    color: DefaultText,
    icon: InfoRailIcon_legacy,
    iconColor: InfoIconFill,
    borderColor: DefaultBorderColor,
  },
  pending: {
    bg: DefaultFill,
    color: DefaultText,
    icon: StatePendingIcon,
    iconColor: PendingIconFill,
    borderColor: DefaultBorderColor,
  },
  loading: {
    bg: LoadingFill,
    color: DefaultText,
    borderColor: LoadingBorderColor,
    headerContent: <Bars />,
  },
};
